var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    fill: "#FFF",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.193.916a.69.69 0 1 1 .976.975L2.632 4.428h12.393a.69.69 0 1 1 0 1.379H2.648l2.52 2.52a.69.69 0 1 1-.975.976L.488 5.597a.69.69 0 0 1 0-.975z"
  })));
};
export default SvgChevronLeft;